/**
 * AMPI Riviera Nayarit - Datos de Beneficios Nacionales
 * Migrado desde Módulo A - Enero 2026
 */

export interface BeneficioNacional {
  id: string;
  nombre: string;
  categoria: string;
  categoriaLabel: string;
  descripcion: string;
  beneficios: string[];
}

export interface CategoriaNacional {
  id: string;
  label: string;
  icon: string;
}

export const BENEFICIOS_NACIONALES: BeneficioNacional[] = [
  // ========== SEGUROS Y FINANZAS ==========
  {
    id: "hipotecaria-uno",
    nombre: "Hipotecaria UNO",
    categoria: "seguros",
    categoriaLabel: "Seguros y Finanzas",
    descripcion: "Productos financieros y seguros para profesionales inmobiliarios.",
    beneficios: [
      "Seguro de Despensa Protegida: Cobertura mensual $2,000-$10,000 en Walmart",
      "Seguro de Vida: Desde $60,000 anuales, primas desde $400",
      "Seguro de Salud: Hospitalización y diagnóstico, primas desde $590",
      "Plan de Retiro con Inversión Inmobiliaria desde $500,000"
    ]
  },
  {
    id: "eci-asesores",
    nombre: "ECI Asesores y ANCAIS",
    categoria: "seguros",
    categoriaLabel: "Seguros y Finanzas",
    descripcion: "Consultoría integral y seguros con precios preferenciales.",
    beneficios: [
      "Gastos médicos mayores y menores",
      "Seguro de vida con recuperación",
      "Plan de retiro, ahorro educativo y ahorro mujer",
      "Seguros para autos, viajeros, fianzas y responsabilidad civil",
      "Consultoría fiscal, financiera, contable y jurídica"
    ]
  },
  {
    id: "grupo-kc",
    nombre: "Grupo KC",
    categoria: "seguros",
    categoriaLabel: "Seguros y Finanzas",
    descripcion: "Financiamiento flexible para seguros.",
    beneficios: [
      "Pago a 12 meses sin intereses en seguros de vida",
      "Pago a 12 meses sin intereses en gastos médicos mayores"
    ]
  },
  {
    id: "ana-seguros",
    nombre: "ANA Seguros",
    categoria: "seguros",
    categoriaLabel: "Seguros y Finanzas",
    descripcion: "Seguros de auto con coberturas innovadoras.",
    beneficios: [
      "Coberturas innovadoras en seguros de auto",
      "Herramientas de gestión virtual"
    ]
  },

  // ========== EDUCACION ==========
  {
    id: "universidades",
    nombre: "Universidades y Posgrados",
    categoria: "educacion",
    categoriaLabel: "Educación",
    descripcion: "Descuentos en instituciones educativas de prestigio.",
    beneficios: [
      "10% a 40% descuento en colegiaturas y posgrados inmobiliarios",
      "Tecnológico de Monterrey",
      "Universidad de las Américas Puebla (UDLAP)",
      "Universidad Anáhuac",
      "URN y Centro de Estudios Veracruz"
    ]
  },
  {
    id: "idiomas",
    nombre: "Centros de Idiomas",
    categoria: "educacion",
    categoriaLabel: "Educación",
    descripcion: "Cursos de idiomas con precios especiales.",
    beneficios: [
      "American Standard Centro de Idiomas",
      "Berlitz",
      "Cursos presenciales y en línea con descuento"
    ]
  },

  // ========== TECNOLOGIA ==========
  {
    id: "flexmls",
    nombre: "Flexmls by FBS",
    categoria: "tecnologia",
    categoriaLabel: "Tecnología",
    descripcion: "Plataforma de Multilisting profesional.",
    beneficios: [
      "Multilisting nacional e internacional",
      "Tarifa anual de $8,900",
      "Un mes gratis para asociados AMPI"
    ]
  },
  {
    id: "contabilidad-digital",
    nombre: "Contabilidad Digital",
    categoria: "tecnologia",
    categoriaLabel: "Tecnología",
    descripcion: "Herramientas de contabilidad y facturación.",
    beneficios: [
      "Contabilizate: Contabilidad digital",
      "Konter: Gestión contable",
      "Expeddify: Expedientes digitales",
      "Timbrame: Timbrado de CFDI"
    ]
  },
  {
    id: "legal-tech",
    nombre: "Soluciones Legales Digitales",
    categoria: "tecnologia",
    categoriaLabel: "Tecnología",
    descripcion: "Firma electrónica y gestión de contratos.",
    beneficios: [
      "Tracer Legal Tech: Blindaje jurídico",
      "Doc2Sign: Firma electrónica",
      "Contratos App y Contratos Renda: Gestión de contratos"
    ]
  },
  {
    id: "cero-papel",
    nombre: "Cero Papel",
    categoria: "tecnologia",
    categoriaLabel: "Tecnología",
    descripcion: "Gestión documental 100% digital.",
    beneficios: [
      "30% de descuento en plataforma",
      "Gestión documental sin papel",
      "Almacenamiento seguro en la nube"
    ]
  },
  {
    id: "marketing-digital",
    nombre: "Marketing y CRM",
    categoria: "tecnologia",
    categoriaLabel: "Tecnología",
    descripcion: "Herramientas de marketing y diseño.",
    beneficios: [
      "InmoApp: CRM inmobiliario",
      "Métrica: Analíticas",
      "Grano Design Studio: Diseño y branding",
      "Activa: Desarrollo web"
    ]
  },

  // ========== HOSPEDAJE ==========
  {
    id: "hoteles",
    nombre: "Hoteles y Hospedaje",
    categoria: "hospedaje",
    categoriaLabel: "Hospedaje",
    descripcion: "Tarifas preferenciales en cadenas hoteleras nacionales e internacionales.",
    beneficios: [
      "Grupo Brisas y Hilton",
      "Holiday Inn Express Reforma",
      "City Express Junior Sullivan",
      "Antaris Valle y Beddo Querétaro",
      "Casa Haus Puebla y Hotel Fray Junípero Serra",
      "Hoteles BF (código 'AMPI')"
    ]
  },

  // ========== TRANSPORTE ==========
  {
    id: "alamo",
    nombre: "Álamo Renta de Autos",
    categoria: "transporte",
    categoriaLabel: "Transporte",
    descripcion: "Renta de vehículos con tarifas preferenciales.",
    beneficios: [
      "Tarifas preferenciales en toda la flota",
      "Código cliente: 417404"
    ]
  },
  {
    id: "mailboxes",
    nombre: "Mail Boxes Etc.",
    categoria: "transporte",
    categoriaLabel: "Transporte",
    descripcion: "Servicios de mensajería y paquetería.",
    beneficios: [
      "Redpack nacional desde $164",
      "DHL Express desde $124"
    ]
  },

  // ========== INMOBILIARIO ==========
  {
    id: "vercomer",
    nombre: "Vercomer y RUV",
    categoria: "inmobiliario",
    categoriaLabel: "Inmobiliario",
    descripcion: "Servicios especializados para el sector.",
    beneficios: [
      "Servicios de dictaminación",
      "Herramientas tecnológicas para el sector",
      "Registro Único de Vivienda"
    ]
  },
  {
    id: "desarrolladores",
    nombre: "Desarrolladores Aliados",
    categoria: "inmobiliario",
    categoriaLabel: "Inmobiliario",
    descripcion: "Comisiones preferenciales con desarrolladores.",
    beneficios: [
      "Casas ARA: Comisiones preferenciales",
      "Xentral: Comisiones por venta",
      "BURÓ Arrendador: Referencias de arrendamiento",
      "LIV: Servicios inmobiliarios"
    ]
  },

  // ========== EVENTOS ==========
  {
    id: "eventos",
    nombre: "Eventos Alebrijes / CIER",
    categoria: "eventos",
    categoriaLabel: "Eventos",
    descripcion: "Servicios para eventos corporativos.",
    beneficios: [
      "Hasta 40% descuento en equipo audiovisual",
      "Plataformas virtuales para eventos",
      "Servicios de primeros auxilios"
    ]
  },

  // ========== COMERCIO ==========
  {
    id: "entretenimiento",
    nombre: "Entretenimiento",
    categoria: "comercio",
    categoriaLabel: "Comercio",
    descripcion: "Descuentos en parques y atracciones.",
    beneficios: [
      "Bioparque Estrella",
      "Acuario Inbursa"
    ]
  },
  {
    id: "comercio-varios",
    nombre: "Comercios Varios",
    categoria: "comercio",
    categoriaLabel: "Comercio",
    descripcion: "Descuentos en tiendas y servicios.",
    beneficios: [
      "Tony Superpapelerías",
      "Julio (moda)",
      "Ópticas +Visión"
    ]
  },

  // ========== GASTRONOMIA NACIONAL ==========
  {
    id: "sabores-ampi",
    nombre: "Sabores AMPI",
    categoria: "gastronomia",
    categoriaLabel: "Gastronomía",
    descripcion: "Beneficios en restaurantes a nivel nacional.",
    beneficios: [
      "Café des Artistes: 20% descuento (todas las marcas)",
      "Amari Sierra: 15% descuento en consumo",
      "Mesón Ibérico: 10% descuento"
    ]
  },
  {
    id: "cafe-inmobiliario",
    nombre: "Café Inmobiliario",
    categoria: "gastronomia",
    categoriaLabel: "Gastronomía",
    descripcion: "Restaurantes participantes del programa.",
    beneficios: [
      "No Soy Juan (Fluvial y Nuevo Vallarta): 15% descuento"
    ]
  }
];

// Categorías disponibles con iconos
export const CATEGORIAS_NACIONALES: Record<string, CategoriaNacional> = {
  todos: { id: "todos", label: "Todos", icon: "bi-grid-3x3-gap" },
  seguros: { id: "seguros", label: "Seguros", icon: "bi-shield-check" },
  educacion: { id: "educacion", label: "Educación", icon: "bi-mortarboard" },
  tecnologia: { id: "tecnologia", label: "Tecnología", icon: "bi-laptop" },
  hospedaje: { id: "hospedaje", label: "Hospedaje", icon: "bi-building" },
  transporte: { id: "transporte", label: "Transporte", icon: "bi-car-front" },
  inmobiliario: { id: "inmobiliario", label: "Inmobiliario", icon: "bi-house" },
  eventos: { id: "eventos", label: "Eventos", icon: "bi-calendar-event" },
  comercio: { id: "comercio", label: "Comercio", icon: "bi-bag" },
  gastronomia: { id: "gastronomia", label: "Gastronomía", icon: "bi-cup-hot" }
};

// Helper para filtrar por categoría
export const getBeneficiosByCategoria = (categoria: string) =>
  categoria === 'todos'
    ? BENEFICIOS_NACIONALES
    : BENEFICIOS_NACIONALES.filter(b => b.categoria === categoria);

// Helper para obtener lista de categorías únicas
export const getCategoriasUnicas = () => {
  const categorias = Array.from(new Set(BENEFICIOS_NACIONALES.map(b => b.categoria)));
  return ['todos', ...categorias];
};
